import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import AliSchwanke from './HighlightedMembers/AliSchwanke';
import { CUIGrid, CUIGridItem } from 'connect-dot-com-ui-components/Components/CUIGrid/CUIGrid';
import DharmeshShah from './HighlightedMembers/DharmeshShah';
import KieranFlanagan from './HighlightedMembers/KieranFlanagan';
import KatherineBoyarsky from './HighlightedMembers/KatherineBoyarsky';
import KyleJepson from './HighlightedMembers/KyleJepson';
export default function HomepageMemberHighlightMobileLayout({
  display
}) {
  return /*#__PURE__*/_jsxs(CUIGrid, {
    display: display,
    templateColumns: "repeat(2, 1fr)",
    gap: 4,
    children: [/*#__PURE__*/_jsx(CUIGridItem, {
      colSpan: 1,
      children: /*#__PURE__*/_jsx(DharmeshShah, {})
    }), /*#__PURE__*/_jsx(CUIGridItem, {
      colSpan: 1,
      children: /*#__PURE__*/_jsx(KieranFlanagan, {})
    }), /*#__PURE__*/_jsx(CUIGridItem, {
      colSpan: 2,
      rowSpan: 1,
      children: /*#__PURE__*/_jsxs(CUIGrid, {
        templateColumns: "repeat(3, 1fr)",
        gap: 4,
        children: [/*#__PURE__*/_jsx(AliSchwanke, {}), /*#__PURE__*/_jsx(KyleJepson, {}), " ", /*#__PURE__*/_jsx(KatherineBoyarsky, {})]
      })
    })]
  });
}